<div
  class="service-list-service-type"
  [attr.data-enabled]="isEnabled()"
  [attr.data-automation]="'service-tile-wrapper'"
  [attr.data-service-type]="serviceType()"
  [attr.data-service-state]="serviceState()"
  [attr.data-tile-type]="tileType()"
  [hidden]="!isDisplayed()"
>
  @if (tileType() === serviceTileType.ADD) {
    <ziro-service-tile-add
      [tooltip]="tooltip()"
      [isEnabled]="isEnabled()"
      [isInProgress]="isInProgress()"
      [isInProgressBadgeText]="isInProgressBadgeText()"
      [serviceName]="serviceName()"
      [icon]="icon()"
      [isAdding]="isAdding()"
      [isDeleted]="isDeleted()"
      (addTileClicked)="onAddTileClicked()"
      [attr.data-automation]="dataAutomation()"
    ></ziro-service-tile-add>
  }

  @if (tileType() === serviceTileType.DELETE) {
    <ziro-service-tile-delete
      [serviceName]="serviceName()"
      [description]="description()"
      [isDeleting]="isDeleting()"
      (confirmButtonClicked)="onDeleteTileConfirmButtonClicked()"
      (cancelButtonClicked)="onDeleteTileCancelButtonClicked()"
      [attr.data-automation]="dataAutomation()"
    ></ziro-service-tile-delete>
  }

  @if (tileType() === serviceTileType.EDIT) {
    <ziro-service-tile-edit
      [isEnabled]="isEnabled()"
      [serviceName]="serviceName()"
      [icon]="icon()"
      [description]="description()"
      [isDeskPhone]="isDeskPhone()"
      [isDevice]="isDevice()"
      [isStatusCheckInProgress]="isStatusCheckInProgress()"
      [hasMultipleDeskPhones]="hasMultipleDeskPhones()"
      [isDeleteShown]="isDeleteShown()"
      [deleteTooltip]="deleteTooltip()"
      [deviceToolip]="deviceToolip()"
      [immediateCallForwardingTooltip]="immediateCallForwardingTooltip()"
      [deviceIconMarkup]="deviceIconMarkup()"
      [tooltip]="tooltip()"
      [isDeleteEnabled]="isDeleteEnabled()"
      [isExchangeEnabled]="isExchangeEnabled()"
      [isExchangeShown]="isExchangeShown()"
      [phone]="phone()"
      [isBeta]="isBeta()"
      [isImmediateCallForwardingEnabled]="isImmediateCallForwardingEnabled()"
      [showWarning]="showWarning()"
      [warningTooltip]="warningTooltip()"
      (editTileClicked)="onEditTileClicked()"
      (editDeskPhoneClicked)="onEditDeskPhoneClicked()"
      (deskPhoneAddClicked)="onEditTileDeskPhoneAddClicked()"
      (deskPhoneCopyClicked)="onEditTileDeskPhoneCopyClicked()"
      (deleteClicked)="onEditTileDeleteClicked()"
      (exchangeClicked)="onEditTileExchangeClicked()"
      [attr.data-automation]="dataAutomation()"
    ></ziro-service-tile-edit>
  }
</div>
